var map = {
	"./1.png": "0946",
	"./2.png": "eb1f",
	"./3.png": "ff10",
	"./4.png": "0b19",
	"./5.png": "cef8",
	"./6.png": "72bf",
	"./admin_panel.png": "19df",
	"./admin_panel_active.png": "05f4",
	"./back.png": "f32f",
	"./bg.png": "fbfe",
	"./logout.png": "6507",
	"./play.png": "9b4e",
	"./search.png": "a751",
	"./settings.png": "9ad9",
	"./vr.png": "46ad",
	"./vr_active.png": "9d60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0195";